<template>
    <div class="cemetery-view">
        <div class="cemetery-details">
            <MaterialSlideShow
                class="slide_fixed_height"
                :smallNavigation="true"
                :bulletss="false"
                :slides="cemeteryImages"
                imageKey="url"
            >
            </MaterialSlideShow>
            <div class="text-content pt-3">
                <div class="cemetery-detail-header">
                    <div class="cemetery-info">
                        <!-- <p class="cemetery-name">{{ cemeteryName }}</p> -->
                        <div class="wrapper row flex-column no-gutters">
                            <div class="col-12">
                                <div class="row no-gutters">
                                    <div class="col-sm d-flex">
                                        <div class="cemetery-status-id">
                                            <h3 class="cemetery-id">
                                                <div class="main-title">
                                                    <span>{{ cemeteryName }}</span>
                                                </div>
                                                <span
                                                    class="cemetery-status"
                                                >
                                                    Público
                                                </span>
                                            </h3>
                                        </div>
                                    </div>
                                    <div class="col-auto"
                                        v-if="allowViewDetail"
                                    >
                                        <button
                                            type="button"
                                            class="cemetery-view-btn btn btn-outline-secondary-main"
                                            :aria-label="`view ${cemeteryName}`"
                                            @click.prevent="onViewDetailCemetery"
                                        >
                                            <span>
                                                <i class="far fa-rectangle-list view-icon"></i>
                                                <p class="text-icon">{{ $t(`${baseTranslateID}.buttons.view`) }}</p>
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="col-12">
                    <ul
                        class="nav nav-tabs mb-3"
                        role="tablist"
                        v-if="numActiveTabs > 1"
                    >
                        <li
                            v-for="(tab, index) in activeTabs"
                            :key="`tab-${index}`"
                            class="nav-item"
                        >
                            <a
                                class="nav-link"
                                :class="{ active: selectedTab.id == tab.id }"
                                data-toggle="tab"
                                role="tab"
                                :id="`item-${tab.id}-tab`"
                                href="javascript:void(0);"
                                :aria-controls="`item-${tab.id}`"
                                :aria-selected="selectedTab.id == tab.id"
                                @click.prevent="activeTab = tab"
                            >
                                {{ $t(tab.name) }}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div
                            v-for="tab in activeTabs"
                            :key="`tab-pane-${tab.id}`"
                            class="tab-pane fade"
                            :class="{ 'show active': selectedTab.id == tab.id }"
                            role="tabpanel"
                            :id="`item-${tab.id}`"
                            :aria-labelledby="`item-${tab.id}-tab`"
                        >
                            <component
                                v-bind:is="tab.component"
                                v-model="tab.model"
                                :panelCfg="panelCfg"
                                :additional="additional"
                                :parentId="parentId"
                                :baseTranslateID="tab.baseTranslateID"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="module">
import { EVENTS } from "../../../shared/config/event-constants";
import CemeteryElementMixin from "../mixins/CemeteryElementMixin";
import { toCamelCase } from "@config/utils";

export default {
    mixins: [CemeteryElementMixin],
    components: {
        CemeteryPublic: () => import(/* webpackChunkName: "cemeteries-cemeterypublic" */ "./../elements/CemeteryPublic"),
        CemeteryAdministration: () => import(/* webpackChunkName: "cemeteries-cemeteryadministration" */ "./../elements/CemeteryAdministration"),
        MaterialSlideShow: () => import(/* webpackChunkName: "MaterialSlideShow" */ "src/components/common/MaterialSlideShow")
    },
    props: {
        eventCemeteryViewDetail: {
            type: String,
            default: EVENTS.SHOW_MODAL_DETAIL_CEMETERY
        },
    },
    data() {
        return {
            form: this.value,
            activeTab: null
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        hasAdministration() {
            return !!this.form?.administration;
        },
        tabKeys() {
            return [
                { key: "administration", default: this.hasAdministration, order: 1, status: this.hasAdministration },
                { key: "public", default: !this.hasAdministration, order: 2, status: true }
            ];
        },
        tabs() {
            let tabs = [];
            this.tabKeys.forEach((tab, index) => {
                let key = tab.key;
                tabs.push({
                    id: key,
                    name: this.$t(`${this.baseTranslateID}.tabs.${key}`),
                    baseTranslateID: `${this.baseTranslateID}`,
                    component: `Cemetery${toCamelCase(key, true)}`,
                    model: this.form,
                    default: tab?.default ?? false,
                    active: tab?.status ?? true,
                    order: tab.order ?? 1
                });
            });

            tabs.sort((a, b) => a.order - b.order);
            return tabs;
        },
        activeTabs() {
            return this.tabs.filter(t => t.active);
        },
        numActiveTabs() {
            return this.activeTabs.length;
        },
        selectedTab() {
            return this.activeTab || this.activeTabs.find(t => t.default) || (this.activeTabs.length ? this.activeTabs[0] : {}) || {};
        },
        cemetery() {
            return this.form ?? {};
        },
        cemeteryCode() {
            return this.cemetery?.code;
        },
        cemeteryName() {
            return this.cemetery?.name;
        },
        cemeteryImages() {
            let imgs = this.cemetery?.images ?? [];
            return imgs.length > 0 ? imgs : [this.defaultImage];
        },

        cemeteryGeometry() {
            return this.cemetery?.geojson;
        },
        cemeteryPoint() {
            return this.cemetery?.location;
        }
    },
    methods: {
        init() {
            this.highlightFeature({
                ...{
                    geojson: this.cemeteryGeometry,
                    zoom: true,
                    layerId: "cemeteries"
                },
                ...this.params
            });
        },
        reset() {
            // Object.assign(this.$data.activeTab, this.$options.data().activeTab);
            this.activeTab = null;
        },
        onViewDetailCemetery(params = {}) {
            if (!this.allowViewDetail) return;

            if (this.eventCemeteryViewDetail) {
                this.$eventBus.publish(
                    this.moduleCode,
                    this.eventCemeteryViewDetail,
                    {
                        data: { ...this.form },
                        // callback: (params = {}) => {
                        //     console.log(params)
                        // }
                    }
                );
            }
        },
    },
    watch: {
        value: {
            deep: true,
            handler: function (value, oldValue) {
                this.reset();
                this.form = value;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.cemetery-view {
    .cemetery-details {
        overflow-x: hidden;

        .text-content {
            .nav-tabs {
                .nav-item {
                    .nav-link {
                        color: #495057;

                        &.active {
                            color: var(--primary-color);
                        }
                    }
                }
            }

            // padding: 16px;
            .cemetery-detail-header {
                display: flex;
                flex-direction: column;
                // row-gap: 8px;
                padding: 0px 0px 25px;

                .cemetery-name {
                    font-size: 1.4rem;
                    letter-spacing: normal;
                    margin: 0 0 5px;
                    color: #181429;
                }

                .cemetery-info {
                    .wrapper {
                        .cemetery-status-id {
                            display: flex;
                            align-self: center;

                            .cemetery-id {
                                text-transform: uppercase;
                                letter-spacing: normal;
                                color: #181429;
                                margin-right: 8px;
                                margin-bottom: 0;

                                .main-title {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                }
                            }
                        }
                    }
                }

                .cemetery-status {
                    color: rgba(24, 20, 41, 0.6);
                    margin: 0px;
                    font-size: 14px;
                    line-height: 16px;
                    gap: 10px;
                    display: flex;
                    align-items: center;
                }

                .cemetery-view-btn {
                    min-width: auto;
                    max-height: 70px;
                    margin: 0 0 10px 10px;
                    padding: 8px 8px;
                    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12);
                    // border: 1.5px solid #e5e5e5;
                    border-radius: 10px;
                    line-height: 25px;

                    .view-icon {
                        font-size: 20px;
                    }

                    .text-icon {
                        font-size: 11px;
                        line-height: 14px;
                        // color: #673ab7;
                        text-align: center;
                        text-transform: uppercase;
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
</style>